<script>
  import { onMount } from "svelte";
  import { writable, derived } from "svelte/store";

  const provas = [
    { prova: "1 - CONGRATULATIONS CAMPINA!" },
    { prova: "2 - COMPLEX PISOS FORCE" },
    { prova: "3 - 'EVOLUTION'" },
    { prova: "4 - BLÁ BLÁ BLÁ" },
    { prova: "5 - CACA CACA CACA" },
    { prova: "6 - BILU BILU TETÉIA" },
  ];

  const data = writable([]);
  const prova = writable("");
  const categoria = writable("");
  const horario = writable("");

  onMount(async () => {
    const response = await fetch("/docs/baterias.json");
    const json = await response.json();
    data.set(json);
  });

  const filteredData = derived(
    [data, categoria, horario],
    ([$data, $categoria, $horario]) => {
      return $data.filter(
        (item) =>
          ($categoria ? item.categoria === $categoria : true) &&
          ($horario ? item.horario === $horario : true)
      );
    }
  );

  const categorias = derived(data, ($data) => [
    ...new Set($data.map((item) => item.categoria)),
  ]);

  const horarios = derived([data, categoria], ([$data, $categoria]) => {
    if ($categoria) {
      return [
        ...new Set(
          $data
            .filter((item) => item.categoria === $categoria)
            .map((item) => item.horario)
        ),
      ];
    }
    return [];
  });

  const isCategoriaDisabled = derived(prova, ($prova) => $prova === "");
  const isHorarioDisabled = derived(
    categoria,
    ($categoria) => $categoria === ""
  );
</script>

<div class="margem">
  <div class="fonte">
    <strong>Resultados das baterias</strong>
  </div>

  <div class="linha fonte2">
    <div class="linha-col1">
      <label for="prova">Provas:</label>
    </div>
    <div class="input-container linha-col2">
      <select style="width: 340px;" id="prova" bind:value={$prova}>
        <!--<option value="">Selecione a Prova</option>-->
        {#each provas as item}
          <option value={item.prova}>{item.prova}</option>
        {/each}
      </select>
    </div>
    <div class="linha-col3"></div>
  </div>

  <div class="linha fonte2">
    <div class="linha-col1">
      <label for="categoria">Categoria:</label>
    </div>
    <div class="linha-col2">
      <select
        style="width: 340px;"
        id="categoria"
        bind:value={$categoria}
        disabled={$isCategoriaDisabled}
      >
        <!--<option value="">Selecione a Categoria</option>-->
        {#each $categorias as categoria}
          <option value={categoria}>{categoria}</option>
        {/each}
      </select>
    </div>
    <div class="linha-col3"></div>
  </div>

  <div class="linha fonte2">
    <div class="linha-col1">
      <label for="horario">Horário da Bateria:</label>
    </div>
    <div class="linha-col2">
      <select
        style="width: 120px;"
        id="horario"
        bind:value={$horario}
        disabled={$isHorarioDisabled}
      >
        <!--<option value="">Selecione o Horário</option>-->
        {#each $horarios as horario}
          <option value={horario}>{horario}</option>
        {/each}
      </select>
    </div>
    <div class="linha-col3"></div>
  </div>
</div>

{#if $horario.includes(":")}
  <div style="display: flex; width: 100%;">

    <div style="display: flex; width: 25%;"></div>

    <div style="display: flex; width: 75%;">
      <div class="cabecalho cabecalho-azulEscuro" style="width: 20%">
        Prova 1
      </div>
      <div class="cabecalho cabecalho-azulEscuro" style="width: 20%">
        Prova 2
      </div>
      <div class="cabecalho cabecalho-azulEscuro" style="width: 20%">
        Prova 3
      </div>
      <div class="cabecalho cabecalho-azulEscuro" style="width: 20%">
        Prova 4
      </div>
      <div class="cabecalho cabecalho-azulEscuro" style="width: 20%">
        Prova 5
      </div>
    </div>

  </div>

  <div style="display: flex; width: 100%;">
    
    <div style="display: flex; width: 25%;">
      <div class="cabecalho cabecalho-azulClaro" style="width: 100%">
        Equipe / Atleta(s)
      </div>
    </div>

    <div style="display: flex; width: 75%;">
      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Bike</div>
      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Corrida</div>

      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Bike 2</div>
      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Corrida 2</div>

      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Bike 3</div>
      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Corrida 3</div>

      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Bike 4</div>
      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Corrida 4</div>

      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Bike 5</div>
      <div class="cabecalho cabecalho-azulClaro" style="width: 10%">Corrida 5</div>

    </div>

  </div>

  {#each $filteredData as item}
    <div style="display: flex; width: 100%;">
      <div style="display: flex; width: 25%;">
        <div class="registro" style="width: 100%"> {item.equipe ? `${item.equipe} (${item.name})` : item.name}</div>
      </div>

      <div style="display: flex; width: 15%;">
        <div class="registro" style="width: 50%;">
          <div class="registroInterno" style="width: 50%">
            4500m
          </div>
          <div class="registroInterno" style="width: 50%">
            00:17:00
          </div>
        </div>

        <div class="registro" style="width: 50%">
          <div class="registroInterno" style="width: 50%">
            3000m
          </div>
          <div class="registroInterno" style="width: 50%">
            00:15:45
          </div>
        </div>
      </div>
    </div>
  {/each}
{/if}

<style>
  .cabecalho {
    text-align: center;
    border: 2px solid #4bb8f3; /* Define a borda com 2px de largura e cor preta */
    border-radius: 5px; /* Define o arredondamento dos cantos */
    padding: 7px; /* Adiciona um preenchimento interno à div */
    font-size: 15px;
    font-weight: bold;
    margin: 0px;
  }

  .cabecalho-azulClaro {
    background: #d3f3ff;
  }

  .cabecalho-azulEscuro {
    background: #418ba5;
  }

  .registro {
    text-align: left;
    border: 2px solid #dcf6fb; /* Define a borda com 2px de largura e cor preta */
    border-radius: 0px; /* Define o arredondamento dos cantos */
    background: #ffffff;
    padding: 7px; /* Adiciona um preenchimento interno à div */
    font-size: 13px;
    color: #024c91;
    font-weight: bold;
    margin: 0px;
  }

  .registroInterno {
    text-align: center;
    background: #ffffff;
    padding: 0px; /* Adiciona um preenchimento interno à div */
    font-size: 13px;
    color: #024c91;
    font-weight: bold;
    margin: 0px;
  }

  select,
  input {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.3rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition:
      border-color 0.3s,
      box-shadow 0.3s;
  }

  select {
    background-color: #ffffff;
    color: #000000;
  }

  select:disabled {
    background-color: #eeebeb;
    color: #afacac;
  }
  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .fonte {
    font-size: 30px;
    font-weight: bold;
    color: #000080;
    text-align: center;
  }

  .fonte2 {
    font-size: 16px;
    font-weight: bold;
  }

  .linha {
    display: flex;
    width: 100%;
  }

  .linha-col1,
  .linha-col2,
  .linha-col3 {
    display: flex;
    height: 100%;
  }

  .linha-col1 {
    width: 15%;
  }

  .linha-col2 {
    width: 25%;
  }

  .linha-col3 {
    width: 60%;
  }
</style>
